export class BlockModel {
    constructor(data) {
        this.id = "BlockModel_" + Math.floor(Math.random() * 100000);
        this.logo = `${import.meta.env.VITE_MEDIA_ENDPOINT}${data.logo}`
        this.title = data.title;
        this.text = data.text;
        this.link_text = data.link_text;
        this.help_text = data.help_text;
        this.link = data['link'];
        this.is_photo = Boolean(parseInt(data['is_photo']));
        this.has_link = typeof data['has_link'] !== 'undefined' ? Boolean(parseInt(data['has_link'])) : !this.is_photo;
    }
}